import { APIS } from "../../../APIS";
import { IDS } from "../../../IDS";
import { GET, POST } from "../../../Methods";

export const GetAll = async (filter) => {
  return await GET(
    `${APIS.Profile.Settlement.Settlement}?client_id=${filter?.client_id
      ?.value || ""}&s_date=${filter?.s_date || ""}&e_date=${filter?.e_date ||
      ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
      IDS.PERPAGE}`,
  );
};

export const AllUserSettlement = async (filter) => {
  return await GET(
    `${APIS.Profile.Settlement.AllUserSettlement}?client_id=${filter?.client_id
      ?.value || ""}&s_date=${filter?.s_date || ""}&e_date=${filter?.e_date ||
      ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
      IDS.PERPAGE}`,
  );
};

export const AllUsers = async () => {
  try {
    return await GET(APIS.Profile.Users);
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const ManageSettlement = async (filter) => {
  return await GET(APIS.Profile.Settlement.ManageSettlement);
};

export const ManageSettlementList = async (filter) => {
  return await GET(APIS.Profile.Settlement.ManageSettlementList);
};

export const GetOne = async (id) => {
  return await GET(`${APIS.Profile.Settlement.Settlement}/${id}`);
};

export const OneSettlement = async (id) => {
  return await GET(`${APIS.Profile.Settlement.OneSettlement}/${id}`);
};

export const AllSettlement = async () => {
  return await GET(`${APIS.Profile.Settlement.AllSettlement}`);
};
